
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.581 14.18l.072-.209 1.641.529v-.358a.366.366 0 00-.172-.358c-.21-.133-1.388-.915-1.388-.915v-.101l.267-1.187.477-.32h.291l.172-.754.066-.038.048-.925s.048-.31-.114-.31h-.477a.135.135 0 00-.12.124c0 .11-.095-.033-.095-.033V7.841H9.46l3.602 1.026.186.2v-.234a1.307 1.307 0 00-.21-.591c-.138-.096-3.53-1.794-3.53-1.794l-1.226-.882-.033-2.81S8.015.5 7.5.5s-.749 2.256-.749 2.256l-.033 2.81-1.226.882S2.1 8.146 1.962 8.242c-.117.177-.189.38-.21.591v.234l.186-.2L5.54 7.841h1.211v1.484s-.095.138-.095.033a.135.135 0 00-.12-.124h-.477c-.162 0-.114.31-.114.31l.048.925.066.038.172.754h.291l.477.32.277 1.168v.101s-1.178.782-1.388.915a.364.364 0 00-.172.358v.358l1.641-.53.071.21h.129l.024.019z"}})])
          )
        }
      }
    